import { useTranslation } from 'react-i18next'
import { useCurrentAccount } from '@/features/auth/hooks/useCurrentAccount'
import styles from '../SettingsModal.module.scss'

/**
 * The restaurants this account can open, the open one marked. Read only: the
 * account menu is where another one is opened. The backend's list carries no
 * role, so none is shown.
 */
function AccountRestaurantsField() {
  const { t } = useTranslation()
  const { restaurants, restaurantId } = useCurrentAccount()

  return (
    <ul className={styles.restaurantList}>
      {restaurants.map(restaurant => (
        <li key={restaurant.id} className={styles.restaurantRow}>
          <span className={`body-medium ${styles.restaurantName}`}>
            {restaurant.name}
          </span>
          {String(restaurant.id) === restaurantId && (
            <span className={`body-small ${styles.fieldHint}`}>
              {t('SETTINGS.ACCOUNT.VENUE_CURRENT')}
            </span>
          )}
        </li>
      ))}
    </ul>
  )
}

export default AccountRestaurantsField
